import React, {Component} from 'react';
import styles from './PageHeader.scss';
import classNames from 'classnames/bind';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import {throttle} from 'lodash';
import {AwairLogoIcon} from '../../atoms';

const cx = classNames.bind(styles);

class PageHeaderStore {
  @observable isScrolled = false;
  @observable isMobileView = window.innerWidth < 769;

  @action scrollHeader = () => this.isScrolled = true;
  @action unscrollHeader = () => this.isScrolled = false;
  @action checkWindowWidth = (paramWindowWidth) => this.isMobileView = paramWindowWidth < 769;
}

const pageHeaderStore = new PageHeaderStore();

@observer
class PageHeader extends Component {
  handleScroll = throttle(() => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isScrolledHeader = scrollTop > 0;

    isScrolledHeader
      ? pageHeaderStore.scrollHeader()
      : pageHeaderStore.unscrollHeader();
  }, 500);

  handleResize = throttle(() => {
    pageHeaderStore.checkWindowWidth(window.innerWidth);
  }, 500);

  componentDidMount() {
    const {handleScroll, handleResize} = this;

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
  }

  render() {
    const {reverse} = this.props;
    const {isScrolled, isMobileView} = pageHeaderStore;

    return (
      <header className={cx('page-header', (isScrolled && 'scrolled'), (reverse && 'reverse'))}>
        <div className={cx('page-header-container')}>
          <div className={cx('page-header-container__logo')}>
            <AwairLogoIcon
              color={(isScrolled || isMobileView || reverse) ? '#4A4A4A' : '#FFFFFF'}
            />
          </div>
          <div className={cx('page-header-container__buy-now')}>
            <a
              href={process.env.REACT_APP_BUY_AMAZON}
              target='_blank'
              rel='noopener noreferrer'
            >
              <button className={cx('page-header-container__buy-now-button')}>購入する</button>
            </a>
          </div>
        </div>
      </header>
    );
  }
}

export default PageHeader;


// WEBPACK FOOTER //
// ./src/app/components/organisms/PageHeader/PageHeader.js